import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { lightTheme, darkTheme } from '../theme'; // Import both themes
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Features from '../components/ServicesSection';
import FAQs from '../components/FAQs';
import Contact from '../components/Contact';
import CallToAction from '../components/CallToAction';

const Home = () => {
    const [darkMode] = useState(false);

  

    return (
        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
            <CssBaseline /> {/* Ensures the theme's styles are applied globally */}
            <Hero />
            <About darkMode={darkMode} />
            <Services darkMode={darkMode} />
            <Features darkMode={darkMode} />
            <CallToAction darkMode={darkMode} />
            <FAQs darkMode={darkMode} />
            <Contact darkMode={darkMode} />

       
        </ThemeProvider>
    );
};

export default Home;
